/**
 * Created by 个人设置 on 2016/1/21.
 */
angular.module("myZonePerInfoPerSettingModule",[])
    .controller("myZonePerInfoPerSettingCtrl",["$scope",function($scope){
        console.log("hello！这里是个人设置，谢谢！")
    }]);